var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 15H1.875C.839 15 0 14.16 0 13.125V1.875C0 .839.84 0 1.875 0h16.25C19.161 0 20 .84 20 1.875v11.25C20 14.161 19.16 15 18.125 15zM4.375 2.187c-1.208 0-2.188.98-2.188 2.188 0 1.208.98 2.188 2.188 2.188 1.208 0 2.188-.98 2.188-2.188 0-1.208-.98-2.188-2.188-2.188zM2.5 12.5h15V8.125l-3.419-3.419c-.183-.183-.48-.183-.662 0L8.125 10 5.956 7.831c-.183-.183-.48-.183-.662 0L2.5 10.625V12.5z",
    transform: "translate(2 5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.67367eabbd6be4bfbcd8338dd34207a0.svg";
export { ForwardRef as ReactComponent };